import { Longhand } from "../longhand.js";
import Base from "./border-top-color.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-inline-end-color}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=border-inline-end-color.js.map